// vendor-login-dialog.component.ts
import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { VendorService } from "src/app/services/vendor.service";
import { LoginDataService } from "src/app/login-data.service";
import { AuthService } from "src/app/services/auth.service";
import { Router } from "@angular/router";
import { EncryptionService } from "src/app/encryption.service";

@Component({
  selector: "app-vendor-login-dialog",
  templateUrl: "./vendor-login-dialog.component.html",
  styleUrls: ["./vendor-login-dialog.component.scss"],
})
export class VendorLoginDialogComponent {
  adminLoginForm: FormGroup;
  showpassword: boolean = true;
  vendorData: any;
passwordVisible: boolean = false; 
  constructor(
    private fb: FormBuilder,
    private vendorService: VendorService,
    private authService: AuthService,
    private loginDataService: LoginDataService,
    private router: Router,
    private encryptionService: EncryptionService,
    private dialogRef: MatDialogRef<VendorLoginDialogComponent>
  ) {
    this.adminLoginForm = this.fb.group({
      email: [
        "",
        [Validators.required, Validators.email],
      ],
      password: this.fb.control("", [Validators.required]),
    });
    this.vendorService.vendorIdSubject$.subscribe((obj) => {
      this.vendorData = obj;
      console.log("bbbb", obj);
    });
  }

  toggleShow(event: Event) {
    event.preventDefault();
    this.showpassword = !this.showpassword;
  }

  // onSubmit() {
  //   if (this.adminLoginForm.valid) {
  //     console.log("Form submitted successfully!");
  //     this.validateVendor();
  //   }
  // }
  login() {
    this.dialogRef.close();
    this.router.navigate(["/vendor/login"]);
  }

  async validateVendor() {
    const email = this.adminLoginForm.value["email"];
    const password = this.encryptionService.encrypt256(this.adminLoginForm.value["password"])
    //const password = this.adminLoginForm.value["password"];
    const role = "VENDOR";
    const data = await this.loginDataService.validateVendor(email, password,role);
    console.log("ppp", data);
    if (data) {
      // this.router.navigate(["/vendor"]);
      this.dialogRef.close(this.vendorData.id);
    }

    // this.loginDataService.validateVendor(email, password)
    // .subscribe(
    //   (resp: any) => {
    //     try {
    //       const vendorData = this.loginDataService.handleLoginSuccess(resp);
    //       console.log("Vendor Data:", vendorData); // Debugging line
    //       this.dialogRef.close(vendorData.id);
    //     } catch (error) {
    //       console.error("Error during login success handling:", error);
    //     }
    //   },
    //   (error) => {
    //     console.error("Error during login", error);
    //   }
    // );
  }
  // validateVendor() {
  //   let reqObj = {
  //     email: this.adminLoginForm.value["email"],
  //     password: this.adminLoginForm.value["password"]
  //   };
  //   console.log("Form", this.adminLoginForm.value);
  //   console.log("reqObj", reqObj);

  //   this.vendorService.validateVendor(reqObj).subscribe((resp: any) => {
  //     console.log("Rec profile update success", resp);

  //     if (resp.statusCode == 200) {
  //       this.vendorService.setVendorIdSubject(resp.data);
  //       console.log("ssssss",resp.data)
  //       this.authService.setLoggedIn(true);
  //       this.dialogRef.close(resp.data.id);
  //       console.log("success");
  //     } else {
  //       console.error("Login failed");
  //     }
  //   });
  // }

  goTo(link: any) {
    this.router.navigate([link]);
    this.dialogRef.close();
  }
}
